module.exports = __webpack_public_path__ + "img/incident_seguridad.d7ebde7f.svg";